import React, { useState } from 'react';
import EditIcon from '../../../../../../assets/images/researcher_app/overview/pencil_edit_icon.png';

// This is a field that by default shows a label and a value, 
// but can be edited by pressing an icon to its right. 
// Once in editing mode, there is a save button that pops up next to it.
function EditableField(props) {
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState(props.value);

    function onClickEdit() {
        if (props.editable) {
            setEditing(true);
        }
    }

    function onClickSave() {
        setEditing(false);
        props.onSubmit(value, props.name);
    }

    function onChange(event) {
        setValue(event.target.value);
    }

    const inputHtml = props.type != "comment" ?
        (<input className="editable-field-input" value={value} type={props.type} onChange={onChange} />)
        :
        (<textarea className="editable-field-input" value={value} type={props.type} rows={4} onChange={onChange} />)

    return (
        <div className="editable-field-container">
            <div className="editable-field">
                <div className="editable-field-title">
                    {props.title}
                </div>
                <div className="editable-field-value">
                    {editing ? (
                        <div className="editable-field-input-container">
                            {inputHtml}
                            <button className="editable-field-save" onClick={onClickSave}>Save</button>
                            <div className="editable-field-cancel" onClick={() => setEditing(false)}>Cancel</div>
                        </div>
                    ) : (
                        <div className="editable-field-value-text">
                            {value}
                        </div>
                    )}
                </div>
            </div>
            {props.editable && <div className="editable-field-edit-icon" onClick={onClickEdit}>
                <img src={EditIcon} />
            </div>}
        </div>
    )
}

function NonEditableLink(props) {

    return (
        <div className="editable-field-container">
            <div className="editable-field">
                <div className="editable-field-title">
                    {props.title}
                </div>
                <div className="editable-field-value">
                    <a href={props.value} target="_blank" className="editable-field-value-text">
                        {props.value}
                    </a>
                </div>
            </div>
        </div>
    )
}

function EditableFieldsContainer(props) {
    return (
        <div className="editable-fields-container">
            {props.children}
        </div>
    )
}




export { EditableField, EditableFieldsContainer, NonEditableLink }